import useRoutesHandler from "@/Hooks/useRouteHandler";
import { handleNetworkError } from "@/utility/networkError.utility";
import {
  useAuthServiceMutations,
  useGetAuthUserService,
} from "@repo/api-services/admin";
import { setAuthorizationHeader } from "@repo/api-services/Axios";
import { ILoginSchema } from "../auth.types";
import queryClientGlobal from "@repo/api-services/queryConfig.ts";
import { CACHE_KEYS } from "@repo/api-services/CacheKeys";

export default function useLogin() {
  const { navigate } = useRoutesHandler();
  const { authService } = useGetAuthUserService();
  const { loginMutation, logoutMutation } = useAuthServiceMutations();
  // This token is for dummy puprose

  const handleLogin = async (data: ILoginSchema) => {
    try {
      const response = await loginMutation.mutateAsync(data);
      setAuthorizationHeader(response?.token);

      await authService.refetch();

      navigate("/home");
    } catch (err: any) {
      handleNetworkError(err?.response);
      queryClientGlobal?.invalidateQueries({
        queryKey: [...CACHE_KEYS.CAPTCHA],
      });
      return err;
    }
  };

  const handleLogout = () => {
    logoutMutation.mutateAsync().then(() => {
      authService.refetch();
      localStorage.clear();
      queryClientGlobal?.invalidateQueries({
        queryKey: [...CACHE_KEYS.CAPTCHA],
      });
    });
  };

  return {
    mutations: { loginMutation, logoutMutation },
    functions: { handleLogin, handleLogout },
  };
}
